import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AOS from "aos";
import "aos/dist/aos.css";
import { API_URL } from '../config';
import SEOHead from '../components/SEOHead';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import './jobdetail.css';

const jobData = {
  
   
"digital-marketing-intern": {
    title: "Graduate Internship",    
    location: "Coimbatore",
    posted: "24 Sept 2026",
    type: "Intern",
    level: "Final Year Students / Freshers",
},

"business-development-associate": {
    title: "Business Development Associate",    
    location: "Coimbatore",
    posted: "24 Sept 2026",
    type: "Full-time",
},
 "student-intern": {
    title: "Digital Intern",
    location: "Coimbatore",
    posted: "31 Oct 2025",
    type: "Intern",
    level: "Final Year Students",
},
    "electronics-engineer": {
        title: "Electronic Design Engineer",
        location: "Coimbatore",
        posted: "31 Oct 2025",
        type: "Full-time",
        level: "2+ years",
    },
    "fsd-intern": {
        title: "Full-Stack Developer",
        location: "Coimbatore",
        posted: "31 Oct 2025",
        type: "Full-time",
        level: "0 - 1 year",
    },
    "project-admin": {
        title: "Project Administrator",
        location: "Coimbatore",
        posted: "20 Nov 2025",
        type: "Full-time",
        level: "0 - 1 year",
    },
    "firmware-dev": {
        title: "Firmware Developer - Medical Devices",
        location: "Coimbatore",
        posted: "31 Oct 2025",
        type: "Full-time",
        level: "0 - 1 year",
    },
    "junior-electronics-engineer": {
        title: "Junior Electronics Engineer",
        location: "Coimbatore",
        posted: "07 Nov 2025",
        type: "Full-time",
        level: "0 - 1 year",
    },
    "seo-analyst":{
        title: "SEO Analyst",
        location: "Coimbatore",
        posted: "20 Nov 2025",
        type: "Full-time",
        level: "0 - 1 year",
    },
    "innovation-engineering-graduate-pathway":{
        title: "Innovation & Engineering Graduate Pathway",
        location: "Coimbatore",
        posted: "26 Dec 2025",
        type: "Full-time / Part-time",
        level: "Graduates",
    },
    "electronics-intern": {
        title: "Electronics Intern",
        location: "Coimbatore",
        posted: "09 June 2026",
        type: "Intern",
        level: "College Students",
    },
    "ai-intern": {
        title: "AI Data Engineer Intern",
        location: "Coimbatore ( On - site )",
        posted: "15 June 2026",
        type: "Intern",
        level: "0 - 6 months",
    }
};

const JobApplicationForm = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const job = jobData[jobId];
  
  const [hasExperience, setHasExperience] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [motivationWordCount, setMotivationWordCount] = useState(0);
  const [dobError, setDobError] = useState("");
  const [coverLetterError, setCoverLetterError] = useState("");
  const [pasteMessage, setPasteMessage] = useState("");
  const [validationBanner, setValidationBanner] = useState("");
  const [filledFieldsCount, setFilledFieldsCount] = useState(0);
  
  const currentYear = new Date().getFullYear();
  const maxDate = `${currentYear - 18}-12-31`;

  useEffect(() => {
    if (!job) {
      navigate('/careers');
    }
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, [job, navigate]);

  const handleFieldChange = () => {
    // Only run in browser environment
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }
    
    const form = document.querySelector('.application-form');
    if (form) {
      const inputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="date"], select, textarea');
      let count = 0;
      inputs.forEach(input => {
        if (input.value && input.value.trim() !== '') {
          count++;
        }
      });
      setFilledFieldsCount(count);
    }
  };

  const handleMotivationChange = (e) => {
    const text = e.target.value;
    const words = text.trim().split(/\s+/).filter(word => word.length > 0);
    const wordCount = text.trim() === '' ? 0 : words.length;
    setMotivationWordCount(wordCount);
    
    if (wordCount < 100 && wordCount > 0) {
      setCoverLetterError("Please fill with 100 words to submit the form");
    } else {
      setCoverLetterError("");
    }
    
    handleFieldChange();
  };

  const handleCoverLetterPaste = (e) => {
    e.preventDefault();
    console.log("Paste detected - showing message");
    setPasteMessage("Don't Copy paste");
    console.log("State set, message should appear now");
    setTimeout(() => {
      console.log("Hiding paste message");
      setPasteMessage("");
    }, 3000);
    return false;
  };

  const handleDobChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const selectedYear = selectedDate.getFullYear();
    
    if (selectedYear >= currentYear) {
      setDobError("Please select a date from a previous year");
      e.target.setCustomValidity("Please select a date from a previous year");
    } else if (selectedYear > currentYear - 18) {
      setDobError("You must be at least 18 years old");
      e.target.setCustomValidity("You must be at least 18 years old");
    } else {
      setDobError("");
      e.target.setCustomValidity("");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;
    
    if (file) {
      if (file.size > maxSize) {
        setFileError("File size must be less than 5MB");
        setSelectedFile(null);
        e.target.value = "";
      } else {
        setFileError("");
        setSelectedFile(file);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const form = e.target;
    
    // Check word count first
    if (motivationWordCount < 100) {
      setValidationBanner("Please ensure all fields are filled correctly. Minimum 100 words required for motivation statement.");
      setTimeout(() => {
        setValidationBanner("");
      }, 3000);
      return;
    }
    
    // Manually check each required field and scroll to first empty one
    const requiredFields = form.querySelectorAll('[required]');
    let firstInvalid = null;
    
    for (let field of requiredFields) {
      if (!field.value || !field.checkValidity()) {
        firstInvalid = field;
        break;
      }
    }
    
    if (firstInvalid) {
      console.log('=== FOUND INVALID FIELD ===');
      console.log('Field name:', firstInvalid.name);
      console.log('Field type:', firstInvalid.type);
      
      // Get the element's position
      const rect = firstInvalid.getBoundingClientRect();
      const absoluteElementTop = rect.top + window.pageYOffset;
      const elementHeight = rect.height;
      const viewportHeight = window.innerHeight;
      const currentScrollY = window.pageYOffset;
      
      // Calculate the center position - element should be at viewport center
      const scrollToPosition = absoluteElementTop - (viewportHeight / 2) + (elementHeight / 2);
      
      // Debug logging
      console.log('=== SCROLL DEBUG ===');
      console.log('Element rect.top:', rect.top);
      console.log('Current scroll Y:', currentScrollY);
      console.log('Absolute element top:', absoluteElementTop);
      console.log('Element height:', elementHeight);
      console.log('Viewport height:', viewportHeight);
      console.log('Calculated scroll position:', scrollToPosition);
      console.log('Scroll distance:', scrollToPosition - currentScrollY);
      
      // Scroll to center the element
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });
      
      // Focus and show validation after scroll
      setTimeout(() => {
        firstInvalid.focus();
        firstInvalid.reportValidity();
        console.log('After scroll - window.pageYOffset:', window.pageYOffset);
      }, 500);
      
      return;
    }
    
    if (motivationWordCount < 100) {
      Swal.fire({
        title: "Incomplete Application",
        text: `Please write at least 100 words in your motivation statement. Current: ${motivationWordCount} words`,
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }
    
    if (dobError) {
      Swal.fire({
        title: "Invalid Date of Birth",
        text: dobError,
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }
    
    setIsSubmitting(true);

    const formData = new FormData(form);
    
    let fileData = null;
    if (selectedFile) {
      const reader = new FileReader();
      fileData = await new Promise((resolve) => {
        reader.onloadend = () => {
          resolve({
            filename: selectedFile.name,
            content: reader.result.split(',')[1],
            mimetype: selectedFile.type,
            size: selectedFile.size
          });
        };
        reader.readAsDataURL(selectedFile);
      });
    }
    
    const data = {
      first_name: formData.get("first_name"),
      last_name: formData.get("last_name"),
      location: formData.get("location"),
      contact_number: formData.get("contact_number"),
      address: formData.get("address"),
      dob: formData.get("dob"),
      college: formData.get("college"),
      course: formData.get("course"),
      department: formData.get("department"),
      passed_out_year: formData.get("passed_out_year"),
      linkedin_url: formData.get("linkedin_url"),
      email: formData.get("email"),
      experience: formData.get("experience"),
      work_experience: formData.get("work_experience") || "",
      disability: formData.get("disability"),
      cover_letter: formData.get("cover-letter"),
      job_title: job.title,
      job_id: jobId,
      attachment: fileData
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 45000);

    try {
      const response = await fetch(`${API_URL}/api/send-application`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      const result = await response.json();

      if (result.success) {
        setIsSubmitting(false);
        
        // Show success modal with improved styling
        const swalResult = await Swal.fire({
          title: "Application Submitted!",
          html: `
            <div style="text-align: center;">
              <div class="custom-checkmark">
                <svg width="90" height="90" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="40" r="38" stroke="#4CAF50" stroke-width="4" fill="none"/>
                  <path d="M25 40L35 50L55 30" stroke="#4CAF50" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p style="margin: 25px 0 0 0; font-size: 18px; color: #555; line-height: 1.6; font-weight: 500;">
                Thank you for applying. We'll review your application and get back to you shortly.
              </p>
            </div>
          `,
          icon: null,
          showCancelButton: true,
          confirmButtonText: "Return to Jobs",
          cancelButtonText: "Home",
          confirmButtonColor: "transparent",
          cancelButtonColor: "transparent",
          reverseButtons: true,
          customClass: {
            popup: 'custom-swal-popup-large',
            title: 'custom-swal-title-large',
            htmlContainer: 'custom-swal-html',
            confirmButton: 'custom-swal-button-large',
            cancelButton: 'custom-swal-button-large'
          },
          buttonsStyling: false
        });
        
        // Navigate based on user choice
        if (swalResult.isConfirmed) {
          navigate('/careers');
        } else if (swalResult.dismiss === Swal.DismissReason.cancel) {
          navigate('/');
        }
      } else {
        setIsSubmitting(false);
        Swal.fire({
          title: "Submission Failed",
          text: result.error || "We couldn't submit your application. Please try again or contact us directly if the problem persists.",
          icon: "error"
        });
      }
    } catch (error) {
      clearTimeout(timeoutId);
      setIsSubmitting(false);
      
      if (error.name === 'AbortError') {
        Swal.fire({
          title: "Request Timed Out",
          text: "The submission took too long to complete. Please check your internet connection and try again.",
          icon: "warning"
        });
      } else {
        Swal.fire({
          title: "Network Error",
          text: "Unable to connect to the server. Please check your connection and try again.",
          icon: "error"
        });
      }
    }
  };

  if (!job) return null;

  const breadcrumbItems = [
    { label: 'Careers', path: '/careers' },
    { label: job.title, path: `/careers/${jobId}` },
    { label: 'Apply' }
  ];

  return (
    <>
      <SEOHead
        title={`Apply for ${job.title} - AK Consultants`}
        description={`Submit your application for ${job.title} position at AK Consultants in ${job.location}`}
        keywords={`${job.title}, ${job.location}, job application, careers, AK Consultants`}
      />

      <div className="job-application-page">
        {/* Hero Section with Light Blue Background */}
        <div className="application-hero-section">
          <Breadcrumb customItems={breadcrumbItems} />
          <div className="application-hero-content">
            <h2>{job.location}</h2>
            <h1>Apply for {job.title}</h1>
            <p className="job-meta-info">
              <span>{job.type}</span>{job.level && <> • <span>{job.level}</span></>}
            </p>
            <p className="form-instruction">( Please fill out the form below to submit your application )</p>
          </div>
        </div>

        {/* Form Container with White Background */}
        <div className="application-container" data-aos="fade-up">
          <form onSubmit={handleSubmit} className="application-form" noValidate>
            <div className="form-row">
              <div>
                <label>First Name<span className="required-asterisk">*</span></label>
                <input type="text" name="first_name" onChange={handleFieldChange} required />
              </div>
              <div>
                <label>Last Name<span className="required-asterisk">*</span></label>
                <input type="text" name="last_name" onChange={handleFieldChange} required />
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>City<span className="required-asterisk">*</span></label>
                <input type="text" name="location" onChange={handleFieldChange} required />
              </div>
              <div>
                <label>Contact Number<span className="required-asterisk">*</span></label>
                <input 
                  type="text" 
                  name="contact_number" 
                  pattern="[0-9]{10}" 
                  title="Please enter a valid 10-digit mobile number"
                  maxLength="10"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    handleFieldChange();
                  }}
                  required 
                />
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>Location<span className="required-asterisk">*</span></label>
                <input type="text" name="address" onChange={handleFieldChange} required />
              </div>
              <div>
                <label>Date of Birth<span className="required-asterisk">*</span></label>
                <input 
                  type="date" 
                  name="dob" 
                  max={maxDate}
                  onChange={(e) => {
                    handleDobChange(e);
                    handleFieldChange();
                  }}
                  required 
                />
                {dobError && (
                  <small style={{ color: 'red', display: 'block', marginTop: '5px' }}>
                    {dobError}
                  </small>
                )}
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>Email Address<span className="required-asterisk">*</span></label>
                <input type="email" name="email" onChange={handleFieldChange} required />
              </div>
              <div>
                <label>College Name<span className="required-asterisk">*</span></label>
                <input type="text" name="college" onChange={handleFieldChange} required />
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>Course Name (Highest Qualification)<span className="required-asterisk">*</span></label>
                <input type="text" name="course" onChange={handleFieldChange} required />
              </div>
              <div>
                <label>Department</label>
                <input type="text" name="department" onChange={handleFieldChange} />
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>Passed Out Year<span className="required-asterisk">*</span></label>
                <input 
                  type="text" 
                  name="passed_out_year" 
                  pattern="[0-9]{4}" 
                  title="Please enter a valid 4-digit year"
                  maxLength="4"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                    handleFieldChange();
                  }}
                  required 
                />
              </div>
              <div>
                <label>LinkedIn URL<span className="required-asterisk">*</span></label>
                <input type="text" name="linkedin_url" onChange={handleFieldChange} required />
              </div>
            </div>

            <div className="form-row">
              <div>
                <label>Previous Experience</label>
                <select name="experience" onChange={(e) => {
                  setHasExperience(e.target.value === "Yes");
                  handleFieldChange();
                }}>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div>
                <label>Disability</label>
                <select name="disability" onChange={handleFieldChange}>
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Prefer not to disclose">I prefer not to disclose</option>
                </select>
                <small className="note">
                  We respect and welcome diversity. This information will not be used for screening.
                </small>
              </div>
            </div>

            {hasExperience && (
              <div className="full-width">
                <label>About your work experience</label>
                <textarea name="work_experience" className="work-experience-field" onChange={handleFieldChange}></textarea>
              </div>
            )}

            <div className="full-width" style={{ position: 'relative' }}>
              <label>In approximately 100 words, please describe your motivation for applying to this position and explain how your background and values align with our organization<span className="required-asterisk">*</span> <span style={{ fontSize: '12px', fontWeight: '400' }}>(Minimum 100 words required)</span></label>
              <textarea 
                name="cover-letter" 
                placeholder={coverLetterError || "Just be real, we'd rather hear from you than a bot!"} 
                onChange={handleMotivationChange}
                onPaste={handleCoverLetterPaste}
                className={`cover-letter-field ${coverLetterError ? 'error' : ''}`}
                id="cover-letter-textarea"
                required
              ></textarea>
              {pasteMessage && (
                <div className="paste-banner-responsive">
                  Don't copy paste, we'd rather hear from you, than any GPT's
                </div>
              )}
              <div style={{ marginTop: '5px' }}>
                <small style={{ color: motivationWordCount < 100 ? 'red' : 'green', fontSize: '12px', fontWeight: '600' }}>
                  Word count: {motivationWordCount}/100 {motivationWordCount >= 100 ? '✓' : ''}
                </small>
              </div>
            </div>

            <div className="full-width">
              <label>Upload Resume/CV (Optional)</label>
              <input 
                type="file" 
                name="resume" 
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
              />
              {fileError && (
                <small style={{ color: 'red', display: 'block', marginTop: '5px' }}>
                  {fileError}
                </small>
              )}
              <small className="note">
                Maximum file size: 5MB. Accepted formats: PDF, DOC, DOCX
              </small>
            </div>
            
            <div className="form-declaration full-width">
              <input type="checkbox" id="declaration" required />
              <label htmlFor="declaration">
                I hereby confirm that the above details are accurate and true to the best of my knowledge.
              </label>
            </div>

            <div className="form-actions">
              {validationBanner && (
                <div className="validation-banner-responsive">
                  {validationBanner}
                </div>
              )}
              <button 
                type="button"
                onClick={() => navigate(`/careers/${jobId}`)}
                className="btn-secondary"
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn-primary" 
                disabled={isSubmitting || filledFieldsCount < 6}
                title={filledFieldsCount < 6 ? "Please fill at least 6 fields to enable submission" : ""}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Application'}
              </button>
            </div>
          </form>
        </div>

        {isSubmitting && (
          <div className="loading-overlay">
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>Submitting your application...</p>
            </div>
          </div>
        )}
      </div>

      <div style={{ marginTop: '80px' }}>
        <Footer />
      </div>
    </>
  );
};

export default JobApplicationForm;
